module.exports = __webpack_public_path__ + "img/water-droplet-8.c65e2a81.png";